export class DataStorage {
  protected getFromStorage(): any {}

  protected setToStorage(storageValue: any) {}

  constructor() {}
}
